"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _Link = _interopRequireDefault(require("../../Link"));

var _helpers = require("../../../utils/helpers");

var _Typography = require("../../Typography");

var HeaderLogo = function HeaderLogo(_ref) {
  var homeLink = _ref.homeLink,
      color = _ref.color,
      height = _ref.height,
      width = _ref.width;

  var _ref2 = (0, _emotionTheming.useTheme)(),
      slug = _ref2.slug,
      name = _ref2.name;

  var Logo = (0, _helpers.getLogo)(slug);
  return /*#__PURE__*/_react.default.createElement(_Link.default, {
    to: homeLink
  }, /*#__PURE__*/_react.default.createElement(Logo, {
    color: color,
    height: height,
    width: width
  }), /*#__PURE__*/_react.default.createElement(_Typography.HiddenText, null, name, " Logo"));
};

HeaderLogo.propTypes = {
  homeLink: _propTypes.default.string,
  color: _propTypes.default.string,
  height: _propTypes.default.string,
  width: _propTypes.default.string
};
HeaderLogo.defaultProps = {
  homeLink: '/',
  color: '#000',
  height: '53px',
  width: '142px'
};
var _default = HeaderLogo;
exports.default = _default;